import { AxiosRequestConfig, AxiosResponse } from "axios";
import OpenAPIClientAxios from "openapi-client-axios";

import { EnvVar } from "@/env";
import { Client } from "../schema/openapi";
import OpenApiDocument from "../schema/openapi.json";

// API client configuration
const createApiClient = (baseURL?: string) => {
  const getBaseURL = () => {
    if (baseURL) return baseURL;
    return EnvVar.maiteUrl;
  };

  const api = new OpenAPIClientAxios({
    definition: OpenApiDocument as any,
    withServer: {
      url: getBaseURL(),
    },
  });

  return api.initSync<Client>();
};

// API client class with methods
export class MaiteApiClient {
  private client: Client;

  constructor(baseURL?: string) {
    this.client = createApiClient(baseURL);
  }

  // Setup auth interceptor
  setupAuthInterceptor(getAccessToken: () => Promise<string>, onUnauthorized: () => void) {
    // Request interceptor to add auth token
    this.client.interceptors.request.use(
      async (config) => {
        try {
          const token = await getAccessToken();
          config.headers.Authorization = `Bearer ${token}`;
        } catch (error) {
          console.error("Failed to get access token:", error);
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Response interceptor to handle 401s
    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          onUnauthorized();
        }
        return Promise.reject(error);
      }
    );
  }

  // Expose the underlying client for direct API calls
  get api(): Client {
    return this.client;
  }

  // Helper method for custom requests if needed
  async request<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.client.request<T>(config);
  }
}
